(function () {
  // Records each element's original spot so it can be moved back when the
  // viewport drops back below the desktop breakpoint (matchMedia only fires
  // on actual breakpoint crossings, so this also covers the viewport simply
  // starting out narrow, or being resized/rotated after load - not just the
  // one-time "moved on desktop load" case).
  var records = [];

  function moveToSlot(record) {
    var sectionId = record.el.getAttribute('data-xo-move-below-media');
    var slot = document.querySelector('[data-xo-tab-slot="' + sectionId + '"]');
    if (!slot || record.el.parentElement === slot) return;
    slot.appendChild(record.el);
  }

  function moveToOriginal(record) {
    if (record.el.parentElement === record.parent) return;
    if (record.next && record.next.parentElement === record.parent) {
      record.parent.insertBefore(record.el, record.next);
    } else {
      record.parent.appendChild(record.el);
    }
  }

  function apply(mql) {
    records.forEach(function (record) {
      if (mql.matches) {
        moveToSlot(record);
      } else {
        moveToOriginal(record);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-xo-move-below-media]').forEach(function (el) {
      records.push({ el: el, parent: el.parentElement, next: el.nextElementSibling });
    });
    if (!records.length) return;

    var mql = window.matchMedia('(min-width: 768px)');
    apply(mql);
    mql.addEventListener('change', function () {
      apply(mql);
    });
  }

  init();
})();
